export default __webpack_public_path__ + "static/140-bece5fb6992b6676186940d71e7909b0.jpg";